export enum OAuthGrantType {
  PatientCredentials = "patient_credentials",
  DeviceCredentials = "device_credentials",
  RefreshToken = "refresh_token",
  QRCodeCredentials = "qrcode_credentials",
  DottLinkCredentials = "dottlink_credentials",
}
